import React, { useState, useContext, useEffect } from "react";
import LoginForm from "./Components/Pages/LoginForm/Login";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { PrivateRoute, PublicRoute } from "./Components/Layout/Routes";
import { utils } from "./helpers/utils";
import { User } from "./Types/User";
import axios from "axios";
import { axioConfig } from "./helpers/axioConfiguration";
import { Dashboard } from "./Components/Pages/Dashboard/Dashboard";
import { ProvidersList } from "./Components/Pages/Providers/ProvidersList";
import { CreateProvider } from "./Components/Pages/Providers/CreateProvider";
import { EditProvider } from "./Components/Pages/Providers/EditProvider";
import { PublicHome } from "./Components/Pages/PublicHome/PublicHome";
import { PublicProviderList } from "./Components/Pages/PublicProviderList/PublicProviderList";
import { PublicProviderDetail } from "./Components/Pages/PublicProviderList/PublicProviderDetail";
import { PublicEmployerSpotlightPresentation } from "./Components/Pages/EmployerSpotlightPresentation/PublicEmployerSpotlightPresentationList";
import { CreatePresentationForm } from "./Components/Pages/EmployerSpotlightPresentation/CreatePresentationForm";
import { EditPresentationForm } from "./Components/Pages/EmployerSpotlightPresentation/EditPresentationForm";
import { EmployerSpotlightPresentation as EmployerSpotlightPresentationList } from "./Components/Pages/EmployerSpotlightPresentation/EmployerSpotlightPresentationList";
import { BookESPForm } from "./Components/Pages/EmployerSpotlightPresentation/BookESPForm";
import { RSASpecialistMeetingForm } from "./Components/Pages/RSASpecialistMeeting/RSASpecialistMeetingForm";
import { RSAMeetingScheduler } from "./Components/Pages/RSAMeetingScheduler/RSAMeetingScheduler";
import { RSASpecialistMeetingRequestList } from "./Components/Pages/RSASpecialistMeeting/RSASpecialistMeetingRequestList";
import { ESPParticipantsList } from "./Components/Pages/ESPParticipants/ESPParticipantsList";
import { ManageHomepageSections } from "./Components/Pages/ManageHomepageSections/ManageHomePageSections";
import { EditHomepageSectionForm } from "./Components/Pages/ManageHomepageSections/EditHomepageSectionForm";
import { PublicCustomPages } from "./Components/Pages/PublicCustomPages/PublicCustomPages";
import { WorkshopList } from "./Components/Pages/Workshops/WorkshopList";
import { EditWorkshopForm } from "./Components/Pages/Workshops/EditWorkshopForm";
import { PublicWorkshopList } from "./Components/Pages/Workshops/PublicWorkshopList";
import { BookWorkshopForm } from "./Components/Pages/Workshops/BookWorkshopForm";
import { userRole } from "./Constants/userRoles";
import { CASASTestingList } from "./Components/Pages/CASASTesting/CASASTestingList";
import { PublicCASASTestingForm } from "./Components/Pages/CASASTesting/PublicCASASTestingForm";
import { EditCASASTestingForm } from "./Components/Pages/CASASTesting/EditCASASTestingForm";
import { ManageEmploymentOpportunities } from "./Components/Pages/EmploymentOpportunities/EmploymentOpportunities";
import { PublicEmploymentOpportunities } from "./Components/Pages/EmploymentOpportunities/PublicEmployerOpportunities";
import ForgetPasswordForm from "./Components/Pages/ForgetPassword/ForgetPasswordForm";
import ResetPasswordForm from "./Components/Pages/ResetPassword/ResetPasswordForm";
import { UsersList } from "./Components/Pages/Users/UsersList";
import { EditUserForm } from "./Components/Pages/Users/EditUserForm";
import { PublicAbout } from "./Components/Pages/About/About";
import { PublicContact } from "./Components/Pages/Contact/Contact";

import Layout from "./Components/Layout/Layout";

import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap/dist/css/bootstrap.min.css";

import "bootstrap/dist/js/bootstrap.bundle";
import "summernote/dist/summernote-bs4";
import "summernote/dist/summernote-bs4.css";

import "./App.css";

export type AppContextType = {
  isLoggedIn: boolean;
  currentUser?: User | null;
};

export const PUBLIC_SITE_URL_ACTIVE_MAP = {
  Home: ["/"],
  Explore: [
    "/EducationOpportunities",
    "/CareerExploration",
    "/EducationResources",
    "/EmploymentOpportunities",
    "/EducationOpportunitiesList",
  ],
  About: ["/about"],
  Contact: ["/contact"],
};

export const AppContext = React.createContext<AppContextType>({
  isLoggedIn: false,
});
axios.defaults.baseURL =
  process.env.REACT_APP_API_URL || "https://localhost:44307/api/";
//console.log(axios.defaults.baseURL);
axios.defaults.headers.common["Content-Type"] = "application/json";
axioConfig.configurateAxios();
//console.log("Axios configuration completed.");
function App() {
  const publicSiteURLList = [
    "/educationOpportunities",
    "/educationOpportunitiesList",
    "/pages/",
    "/about",
    "contact",
  ];

  const alreadyLoggedin: boolean = utils.getUserFromLocalToken() !== null;
  let user = utils.getUserFromLocalToken() as User | null;
  const [isLoggedin, setIsLoggedin] = useState<boolean>(alreadyLoggedin);
  const [currentUser, setCurrentUser] = useState<User | null>(
    user != null
      ? user
      : {
          FullName: "testAdmin",
          UserId: "0",
        }
  );

  useEffect(() => {
    document.title = "DC DDS Virtural Resource Room";
  }, []);

  const [currUser, setCurrUser] = useState<User | null>(
    utils.getUserFromLocalToken() as User | null
  );
  const isCounselor: boolean | undefined = currUser?.Roles?.includes(
    userRole.Counselor
  );
  const isStaff: boolean | undefined =
    currUser?.Roles?.includes(userRole["RSA Staff"]);
  const isAdmin: boolean | undefined = currUser?.Roles?.includes(
    userRole.Administrator
  );
  const isEmploymentCoordinator: boolean | undefined =
    currUser?.Roles?.includes(userRole["Employment Coordinator"]) ||
    currUser?.Roles?.includes(userRole["Coordinator Supervisor"])
    ;

  return (
    <Router basename="/VRR">
      <AppContext.Provider
        value={{ isLoggedIn: isLoggedin, currentUser: currentUser }}
      >
        <Layout
          isLoggedIn={isLoggedin}
          currentUser={currentUser}
          publicSiteURLList={publicSiteURLList}
        >
          <Switch>
            <PublicRoute exact path="/" isAuthorized={isLoggedin}>
              <PublicHome></PublicHome>
            </PublicRoute>
            <PublicRoute
              exact
              path="/educationOpportunities"
              isAuthorized={isLoggedin}
            >
              <PublicProviderList></PublicProviderList>
            </PublicRoute>
            <PublicRoute exact path="/Pages/:urlcode" isAuthorized={isLoggedin}>
              <PublicCustomPages />
            </PublicRoute>
            <PublicRoute
              exact
              path="/educationOpportunitiesList"
              isAuthorized={isLoggedin}
            >
              <PublicProviderDetail></PublicProviderDetail>
            </PublicRoute>
            <PublicRoute exact path="/login" isAuthorized={isLoggedin}>
              <LoginForm></LoginForm>
            </PublicRoute>
            <PublicRoute exact path="/forgetPassword" isAuthorized={isLoggedin}>
              <ForgetPasswordForm></ForgetPasswordForm>
            </PublicRoute>
            <PublicRoute exact path="/resetPassword" isAuthorized={isLoggedin}>
              <ResetPasswordForm></ResetPasswordForm>
            </PublicRoute>
            <PublicRoute exact path="/about" isAuthorized={isLoggedin}>
              <PublicAbout></PublicAbout>
            </PublicRoute>
            <PublicRoute exact path="/contact" isAuthorized={isLoggedin}>
              <PublicContact></PublicContact>
            </PublicRoute>
            {(isStaff || isAdmin) && (
              <>
                <PrivateRoute exact path="/dashboard" isAuthorized={isLoggedin}>
                  <Dashboard />
                </PrivateRoute>
                <PrivateRoute
                  exact
                  path="/manageHomepageSections"
                  isAuthorized={isLoggedin}
                >
                  <ManageHomepageSections />
                </PrivateRoute>
                <PrivateRoute
                  exact
                  path="/manageEmploymentOpportunities"
                  isAuthorized={isLoggedin}
                >
                  <ManageEmploymentOpportunities />
                </PrivateRoute>
                <PrivateRoute
                  exact
                  path="/editHomepageSection/:sectionId"
                  isAuthorized={isLoggedin}
                >
                  <EditHomepageSectionForm />
                </PrivateRoute>
                <PrivateRoute exact path="/providers" isAuthorized={isLoggedin}>
                  <ProvidersList />
                </PrivateRoute>
                <PrivateRoute
                  exact
                  path="/createProvider"
                  isAuthorized={isLoggedin}
                >
                  <CreateProvider />
                </PrivateRoute>
                <PrivateRoute
                  exact
                  path="/editProvider/:proivderId"
                  isAuthorized={isLoggedin}
                >
                  <EditProvider />
                </PrivateRoute>
                <PrivateRoute
                  exact
                  path="/employerSpotlightPresentationList"
                  isAuthorized={isLoggedin}
                >
                  <EmployerSpotlightPresentationList></EmployerSpotlightPresentationList>
                </PrivateRoute>
                <PrivateRoute
                  exact
                  path="/workshopList"
                  isAuthorized={isLoggedin}
                >
                  <WorkshopList></WorkshopList>
                </PrivateRoute>
                <PrivateRoute
                  exact
                  path="/editWorkshop/:WId"
                  isAuthorized={isLoggedin}
                >
                  <EditWorkshopForm></EditWorkshopForm>
                </PrivateRoute>
                <PrivateRoute
                  exact
                  path="/CASASTestingList"
                  isAuthorized={isLoggedin}
                >
                  <CASASTestingList></CASASTestingList>
                </PrivateRoute>
                <PrivateRoute
                  exact
                  path="/EditCASASTesting/:TId"
                  isAuthorized={isLoggedin}
                >
                  <EditCASASTestingForm></EditCASASTestingForm>
                </PrivateRoute>
                <PrivateRoute
                  exact
                  path="/EditEmployerSpotlightPresentation/:ESPId"
                  isAuthorized={isLoggedin}
                >
                  <EditPresentationForm></EditPresentationForm>
                </PrivateRoute>
                <PrivateRoute
                  exact
                  path="/createPresentation"
                  isAuthorized={isLoggedin}
                >
                  <CreatePresentationForm></CreatePresentationForm>
                </PrivateRoute>
                <PrivateRoute
                  path="/RSASpecialistMeetingScheduler/:MRId"
                  isAuthorized={isLoggedin}
                >
                  <RSAMeetingScheduler></RSAMeetingScheduler>
                </PrivateRoute>
                <PrivateRoute
                  path="/ESPParticipantsList/:ESPId"
                  isAuthorized={isLoggedin}
                >
                  <ESPParticipantsList></ESPParticipantsList>
                </PrivateRoute>
                <PrivateRoute
                  path="/RSASpecialistMeetingRequestList"
                  isAuthorized={isLoggedin}
                >
                  <RSASpecialistMeetingRequestList></RSASpecialistMeetingRequestList>
                </PrivateRoute>
                <PrivateRoute exact path="/UsersList" isAuthorized={isLoggedin}>
                  <UsersList></UsersList>
                </PrivateRoute>
                <PrivateRoute
                  exact
                  path="/EditUser/:UId"
                  isAuthorized={isLoggedin}
                >
                  <EditUserForm></EditUserForm>
                </PrivateRoute>
              </>
            )}
            {(isCounselor || isAdmin) && (
              <>
                <PrivateRoute
                  path="/employerSpotlightPresentation"
                  isAuthorized={isLoggedin}
                >
                  <PublicEmployerSpotlightPresentation></PublicEmployerSpotlightPresentation>
                </PrivateRoute>
                <PrivateRoute
                  path="/JobSeekerWorkshops"
                  isAuthorized={isLoggedin}
                >
                  <PublicWorkshopList></PublicWorkshopList>
                </PrivateRoute>
                <PrivateRoute
                  path="/bookESPSpot/:ESPId"
                  isAuthorized={isLoggedin}
                >
                  <BookESPForm></BookESPForm>
                </PrivateRoute>
                <PrivateRoute
                  path="/bookWorkshop/:WId"
                  isAuthorized={isLoggedin}
                >
                  <BookWorkshopForm></BookWorkshopForm>
                </PrivateRoute>
                <PrivateRoute
                  path="/employmentOpportunities"
                  isAuthorized={isLoggedin}
                >
                  <PublicEmploymentOpportunities></PublicEmploymentOpportunities>
                </PrivateRoute>
                <PrivateRoute
                  path="/registerCASASTesting/:TId"
                  isAuthorized={isLoggedin}
                >
                  <PublicCASASTestingForm></PublicCASASTestingForm>
                </PrivateRoute>
                <PrivateRoute
                  path="/requestRSASpecialistMeeting"
                  isAuthorized={isLoggedin}
                >
                  <RSASpecialistMeetingForm></RSASpecialistMeetingForm>
                </PrivateRoute>
              </>
            )}

            {isEmploymentCoordinator && (
              <>
                <PrivateRoute exact path="/dashboard" isAuthorized={isLoggedin}>
                  <Dashboard />
                </PrivateRoute>
                <PrivateRoute
                  path="/JobSeekerWorkshops"
                  isAuthorized={isLoggedin}
                >
                  <PublicWorkshopList></PublicWorkshopList>
                </PrivateRoute>
                <PrivateRoute
                  path="/requestRSASpecialistMeeting"
                  isAuthorized={isLoggedin}
                >
                  <RSASpecialistMeetingForm></RSASpecialistMeetingForm>
                </PrivateRoute>
                <PrivateRoute
                  path="/RSASpecialistMeetingScheduler/:MRId"
                  isAuthorized={isLoggedin}
                >
                  <RSAMeetingScheduler></RSAMeetingScheduler>
                </PrivateRoute>
                <PrivateRoute
                  path="/RSASpecialistMeetingRequestList"
                  isAuthorized={isLoggedin}
                >
                  <RSASpecialistMeetingRequestList></RSASpecialistMeetingRequestList>
                </PrivateRoute>
              </>
            )}
            <PrivateRoute exact path="/test" isAuthorized={isLoggedin}>
              <div>some test private url</div>
            </PrivateRoute>
            <Route path="*">
              <div >This URL does not match any component.</div>
            </Route>
          </Switch>
        </Layout>
      </AppContext.Provider>
    </Router>
  );
}

export default App;
